<script setup lang="ts">
import { computed } from 'vue'

type LifecycleState = 'raising' | 'closed' | 'exited'

interface BadgeStyle {
  badge: string
}

const props = defineProps<{
  status: string | null | undefined
}>()

const DEFAULT_STYLE: BadgeStyle = {
  badge: 'bg-gray-100 text-gray-600 ring-gray-200',
}

const STYLES: Record<LifecycleState, BadgeStyle> = {
  raising: { badge: 'bg-emerald-50 text-emerald-700 ring-emerald-600' },
  closed: { badge: 'bg-[#e0f0f5] text-[#287a96] ring-[#3092b3]' },
  exited: { badge: 'bg-[#d6e4f0] text-[#1e5470] ring-[#246586]' },
}

const style = computed<BadgeStyle>(() => STYLES[props.status as LifecycleState] ?? DEFAULT_STYLE)
</script>

<template>
  <span
    class="inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-medium ring-1 ring-inset"
    :class="style.badge"
  >
    <span class="uppercase tracking-wide">{{ status ?? '—' }}</span>
  </span>
</template>
